"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notes = void 0;
const react_1 = __importDefault(require("react"));
const ProviderTabs_styles_1 = require("../../ProviderTabs.styles");
const RichTextArrayRenderer_1 = require("../../RichTextArrayRenderer");
const mapNotesFieldToTextContent_1 = require("./mapNotesFieldToTextContent");
const Notes = ({ provider, notesFields, onRichTextLinkClick }) => {
    const mappedContent = react_1.default.useMemo(() => {
        return notesFields === null || notesFields === void 0 ? void 0 : notesFields.map((0, mapNotesFieldToTextContent_1.mapNotesFieldToTextContent)(provider));
    }, [notesFields, provider]);
    return (react_1.default.createElement(ProviderTabs_styles_1.Content, { "data-testid": "notes" },
        react_1.default.createElement(RichTextArrayRenderer_1.RichTextArrayRenderer, { id: `notes-renderer-${provider.id}`, content: mappedContent, onRichTextLinkClick: onRichTextLinkClick })));
};
exports.Notes = Notes;
//# sourceMappingURL=Notes.js.map